import React from 'react';
export const Logo = (<svg version="1.1"  x="0px" y="0px"
	 viewBox="0 0 760.8 158" style={{enableBackground: 'new 0 0 760.8 158'}} >

<g>
	<path className="st0" d="M283.7,78.9c0-10.9-2.1-21.1-6.2-30.7c-4.2-9.6-9.8-17.9-17-25c-7.2-7.1-15.6-12.7-25.2-16.9
		C225.5,2.1,215.3,0,204.4,0c-2.8,0-5.5,0.1-8.1,0.4H0v37.3l52.6-0.5h10.9V158H104V37.2h33.1c-2.2,3.4-4.1,7.1-5.7,10.9
		c-4.2,9.6-6.2,19.8-6.2,30.7c0,10.9,2.1,21.1,6.2,30.7c4.2,9.6,9.8,17.9,17,25s15.5,12.7,25.1,16.8c9.6,4.1,19.9,6.1,30.9,6.1h79.3
		V78.9L283.7,78.9z M188.8,116.4c-4.8-2.2-8.9-5.2-12.4-8.9c-3.5-3.7-6.2-8.1-8.2-13.1c-2-5-3-10.2-3-15.5c0-5.5,1-10.7,3-15.6
		c2-4.9,4.7-9.2,8.2-13c3.5-3.7,7.6-6.7,12.4-8.9c4.8-2.2,10-3.4,15.6-3.4c5.6,0,10.8,1.1,15.6,3.4c4.8,2.2,8.9,5.2,12.4,8.9
		c3.5,3.7,6.2,8,8.2,13c2,4.9,3,10.1,3,15.6c0,5.4-1,10.6-3,15.5c-2,5-4.7,9.3-8.2,13.1c-3.5,3.7-7.6,6.7-12.4,8.9
		c-4.8,2.2-10,3.4-15.6,3.4C198.8,119.8,193.6,118.6,188.8,116.4z"/>
	<path className="st1" d="M375,24.5h-16.4v45.4H352V24.5h-16.3V19H375V24.5z"/>
	<path className="st1" d="M428.8,69.9h-6.7V46.4h-25.7v23.5h-6.7V19h6.7v21.9h25.7V19h6.7V69.9z"/>
	<path className="st1" d="M476.7,46.4h-22.1v18h25.6v5.5h-32.3V19h32v5.5h-25.3v16.4h22.1V46.4z"/>
	<path className="st1" d="M514.4,49.3h-12v20.6h-6.7V19h16.9c5.7,0,10.1,1.3,13.2,3.9c3.1,2.6,4.6,6.4,4.6,11.4c0,3.2-0.9,5.9-2.6,8.3
		c-1.7,2.4-4.1,4.1-7.1,5.3l12,21.6v0.4h-7.2L514.4,49.3z M502.5,43.8h10.3c3.3,0,6-0.9,8-2.6c2-1.7,3-4,3-6.9
		c0-3.2-0.9-5.6-2.8-7.2c-1.9-1.7-4.6-2.5-8.1-2.6h-10.3V43.8z"/>
	<path className="st1" d="M575.1,56.6h-21.3L549,69.9h-6.9L561.5,19h5.9l19.5,50.9H580L575.1,56.6z M555.8,51.1h17.3l-8.7-23.8
		L555.8,51.1z"/>
	<path className="st1" d="M607.6,50v19.9h-6.7V19h18.8c5.6,0,9.9,1.4,13.1,4.3c3.2,2.8,4.7,6.6,4.7,11.3c0,4.9-1.5,8.7-4.6,11.4
		c-3.1,2.7-7.5,4-13.3,4H607.6z M607.6,44.5h12.1c3.6,0,6.3-0.8,8.3-2.5c1.9-1.7,2.9-4.1,2.9-7.3c0-3-1-5.5-2.9-7.3
		c-1.9-1.8-4.5-2.8-7.9-2.8h-12.4V44.5z"/>
	<path className="st1" d="M668.7,44.5L682,19h7.6l-17.5,31.9v19h-6.7v-19L647.8,19h7.7L668.7,44.5z"/>
	<path className="st1" d="M373.3,142H349l-5.5,15.2h-7.9l22.2-58h6.7l22.2,58h-7.8L373.3,142z M351.3,135.7H371l-9.9-27.1L351.3,135.7z"
		/>
	<path className="st1" d="M444.9,138.8c-0.7,6.1-3,10.9-6.8,14.2c-3.8,3.3-8.9,5-15.2,5c-6.9,0-12.3-2.5-16.5-7.4
		c-4.1-4.9-6.2-11.5-6.2-19.7v-5.6c0-5.4,1-10.1,2.9-14.2c1.9-4.1,4.7-7.2,8.2-9.4c3.5-2.2,7.6-3.3,12.3-3.3
		c6.2,0,11.1,1.7,14.8,5.2c3.7,3.4,5.9,8.2,6.5,14.3h-7.7c-0.7-4.6-2.1-8-4.3-10.1c-2.2-2.1-5.3-3.1-9.3-3.1
		c-4.9,0-8.7,1.8-11.5,5.4c-2.8,3.6-4.2,8.8-4.2,15.4v5.6c0,6.3,1.3,11.3,3.9,15c2.6,3.7,6.3,5.6,11,5.6c4.2,0,7.5-1,9.8-2.9
		c2.3-1.9,3.8-5.3,4.5-10.1H444.9z"/>
	<path className="st1" d="M495.5,142h-24.3l-5.5,15.2h-7.9l22.2-58h6.7l22.2,58H501L495.5,142z M473.5,135.7h19.7l-9.9-27.1L473.5,135.7
		z"/>
	<path className="st1" d="M524.9,157.2v-58h16.4c5,0,9.5,1.1,13.4,3.3c3.9,2.2,6.9,5.4,9,9.5c2.1,4.1,3.2,8.8,3.2,14.2v3.7
		c0,5.5-1.1,10.3-3.2,14.4c-2.1,4.1-5.1,7.3-9,9.5c-3.9,2.2-8.5,3.3-13.7,3.4H524.9z M532.5,105.4v45.5h8c5.9,0,10.5-1.8,13.8-5.5
		c3.3-3.7,4.9-8.9,4.9-15.7v-3.4c0-6.6-1.5-11.7-4.6-15.4c-3.1-3.7-7.5-5.5-13.2-5.6H532.5z"/>
	<path className="st1" d="M619.3,130.4h-25.1v20.6h29.2v6.3h-36.9v-58H623v6.3h-28.8v18.7h25.1V130.4z"/>
	<path className="st1" d="M650.9,99.2l19,47.3l19-47.3h9.9v58h-7.6v-22.6l0.7-24.4l-19,47H667l-19-46.9l0.8,24.3v22.6h-7.6v-58H650.9z"
		/>
	<path className="st1" d="M737,128.3l15.1-29.1h8.7l-20,36.4v21.6h-7.6v-21.6l-20-36.4h8.8L737,128.3z"/>
</g>
</svg>
);



// WEBPACK FOOTER //
// ./src/components/svgs/NonLoggedUserLogo.jsx